<template>
  <LayoutStudy
    :layout="mobile ? 'small_screen_layout' : $store.getters.sw_layout_study"
    :spacing="$store.getters.sw_layout_spacing_study"
    :mainWidth="soltab === 'reports' ? 'reports_layout' : 'strategy_layout'"
    :asideHidden="tabMaximized"
    :class="[`laytsttd_${soltab}`, { 'std-active': studyMessages }]"
    data-test="study_data_layout_layer"
  >
    <template #hspots="{ onBottom }">
      <PokerHistoryEvents
        v-bind="hSpotsProps"
        :openToTop="onBottom"
        :totalsItems="l_rep_dynamic.totalsItems"
        dialog="cards-dialog"
        class="solbrowser_hspots"
        style="--clr-hero: var(--clr-hero-default); z-index: 5"
        @click:nodeedit="handleNodeEditClick"
        @click:nodelock="handleNodeLockClick"
        @click:nodecompare="handleNodeCompareClick"
        @click:prefill="handlePrefillClick"
      />
    </template>
    <template #aside>
      <StudyRangesAside
        v-if="soltab !== 'reports'"
        :showFlopContent="showFlopContent"
        :namespace="''"
        :canAISolve="true"
        :soltab="soltab"
        :smallLayout="mobile"
        :landScapeLayout="mobileLandscape"
        :hasTableTile="mobile ? mobileLandscape : true"
        :hasMinify="mobile && !mobileLandscape"
        :rangeTab="$store.getters.sw_tabs_study"
        :tableGroups="l_sol_dynamic.tableGroups"
        :combos="l_sol_dynamic.combos"
        :solution_picked="$store.getters.sol_data_solution_picked"
        :hero="l_sol_static.players[0]"
        :opponent="l_sol_static.players[1]"
        :heroLeft="$store.getters.sol_view_viewProps.heroLeft"
        :hSpot="$store.getters.sol_data_hSpot"
        :street="$store.getters.sol_data_street"
        :blockersFrequencies="l_sol_static.solData.blockers_frequencies"
        :catDraws="l_sol_static.catDraws"
        :catHands="l_sol_static.catHands"
        :catEqBuckets="l_sol_static.catEqBuckets"
        :catEqBucketsAdvanced="l_sol_static.catEqBucketsAdvanced"
        :showBetsIn="showBetsIn"
        :bettingInfo="sol_bettingInfo"
        :isPreflop="sol_isPreflop"
        :mobile="mobile"
        :players="l_sol_static.players"
        :filterCategories="$store.getters.sol_filter_categories"
        :heroHandsIds="heroDetail.hands_ids"
        :heroGroup="heroDetail.group"
        :heroHand="heroDetail.hand"
        :opponentGroup="opponentDetail.group"
        :opponentHandsIds="opponentDetail.hands_ids"
        :filteredHeroHandsIds="$store.getters.sol_filter_playersHandsIds[0]"
        :filteredOpponentHandsIds="$store.getters.sol_filter_playersHandsIds[1]"
        :heroGroupId="heroDetail.group_id"
        :opponentGroupId="opponentDetail.group_id"
        :playersDetail="$store.getters.sol_detail_players"
        :viewProps="$store.getters.sol_view_viewProps"
        :filterCombos="$store.getters.sol_filter_combos"
        :filterEvCompare="$store.getters.sol_filter_ev_comparison"
        :evProps="$store.state.solutions.evProps"
        :tableMouseover="$store.getters.sol_detail_tableMouseover"
        :useHex="useHex"
        :grouping="grouping"
        :hasPremiumGameformat="hasPremiumGameformat"
        :gameformat="gameformat"
        :solElite="solElite"
      ></StudyRangesAside>

      <StudyReportsAside
        v-if="soltab === 'reports'"
        :namespace="''"
        :viewProps="l_rep_dynamic.viewProps"
        :hero="$store.getters.rep_data_hero"
        :opponent="$store.getters.rep_data_opponent"
        :solution="$store.getters.rep_data_solution"
        :hasEmptyFlopBoard="sol_usingCussolReports"
        :isPreflop="rep_isPreflop"
        :showFlopContent="showFlopContent"
        :showBetsIn="showBetsIn"
        :bettingInfo="rep_bettingInfo"
        :grouping="grouping"
        :useHex="useHex"
        :filterCombos="$store.getters.sol_filter_combos"
        :reportItem="$store.getters.rep_data_reportItem"
        :flopGroup="$store.getters.rep_data_flopGroup"
        :hasPremiumGameformat="hasPremiumGameformat"
        :gameformat="gameformat"
        :hSpot="$store.getters.rep_data_hSpot"
        :street="$store.getters.rep_data_street"
        :hSpotStreet="hSpot_street"
        :flopBoard="$store.getters.flop_board"
        :turnFilterHand="$store.getters.rep_turn_filterHand"
        :mobile="mobile"
        :hasLinks="true"
      />
    </template>
    <template #main>
      <div
        v-if="mobile ? !mobileLandscape : false"
        class="d-flex gw_box"
        style="--box-padding: 0 0.25rem; margin: 0 0 0.5rem 0; height: 2.5rem"
      >
        <StudyTableTile
          v-if="mobile && !filterActive"
          :hSpot="$store.getters.sol_data_hSpot"
          :street="$store.getters.sol_data_street"
          :gameformat="gameformat"
          :mobile="mobile"
          :solElite="solElite"
        />
        <StudyFiltersPills
          v-else
          style="--clr-pills-back: var(--clr-black-1)"
          :alwaysVisible="true"
          class="my-auto ml-auto"
          :street="hSpot_street"
          :soltab="soltab"
          :filterCombos="$store.getters.sol_filter_combos"
          :hasFilterIntersection="soltab !== 'reports'"
          :showBetsIn="showBetsIn"
        />
      </div>
      <TabBoxStudy
        class="flex-1"
        :hasGuide="true"
        :scrollToActiveTab="max1280"
        :reportsStreet="hSpot_street"
        :noReports="noReports"
        :isCustomReportsPending
      >
        <template #tabs_after="{ tab }">
          <div
            v-if="!mobile"
            class="d-flex flex-1"
            style="min-width: 0; gap: 0.5rem"
          >
            <StudyFiltersPills
              class="ml-auto"
              :alwaysVisible="true"
              :street="hSpot_street"
              :showBetsIn="showBetsIn"
              :filterCombos="$store.getters.sol_filter_combos"
              :hasFilterIntersection="soltab !== 'reports'"
              :soltab="tab"
            />

            <div
              v-if="!mobile"
              class="d-flex"
              style="gap: 1px"
            >
              <StudyControlsRanges
                v-if="soltab !== 'reports'"
                :hasICMConverter="!!sol_bettingInfo.evIcmConverters[0]"
                style="z-index: 2"
              />
              <StudyControlsReports
                v-if="soltab === 'reports'"
                style="z-index: 2"
                :street="hSpot_street"
                :flopBoard="$store.getters.flop_board"
                :turnFilterHand="$store.getters.rep_turn_filterHand"
              />
              <StudyControlsReportsFilters
                v-if="soltab === 'reports'"
                style="z-index: 2"
                :street="hSpot_street"
              />
              <StudyControlsMain style="z-index: 2" />
            </div>
          </div>
        </template>
        <template #default="{ tab }">
          <StudyReportsMain
            v-if="tab === 'reports'"
            :namespace="''"
            :canAISolve="true"
            :items="l_rep_dynamic.items"
            :flopBoard="$store.getters.flop_board"
            :totalsItems="l_rep_dynamic.totalsItems"
            :viewProps="l_rep_dynamic.viewProps"
            :content="l_rep_dynamic.viewProps.content"
            :legendVertical="true"
            :colStyleKey="'strategy'"
            :useHex="useHex"
            :playerRelPosition="$store.getters.rep_data_hero.relative_position"
            :isPreflop="rep_isPreflop"
            :reportItemId="$store.getters.rep_data_reportItemId"
            :hero="$store.getters.rep_data_hero"
            :opponent="$store.getters.rep_data_opponent"
            :solution="$store.getters.rep_data_solution"
            :flopGroup="$store.getters.rep_data_flopGroup"
            :eveqeqrAxes="$store.getters.rep_data_eveqeqrAxes"
            :grouping="grouping"
            :showBetsIn="showBetsIn"
            :bettingInfo="{ showEvIn, pot: $store.getters.rep_data_hSpot.pot }"
            :mobile="mobile"
            :colorCoding="$store.getters.sw_reports_colorcoding01"
            :navResizeDeps="$store.getters.rep_nav_resizeDeps"
            :street="$store.getters.rep_data_street"
            :hSpot="$store.getters.rep_data_hSpot"
            :filterCombos="$store.getters.sol_filter_combos"
            :hasPremiumGameformat="hasPremiumGameformat"
            :gameformat="gameformat"
            :hasLinks="true"
          />
          <keep-alive max="1">
            <template v-if="$store.getters.user_has_flag('SOL_3WAY')">
              <StudyRangesMain2
                v-if="tab === 'strategy' || tab === 'range'"
                :namespace="''"
                :canAISolve="true"
                :rangeTab="tab"
                :tableGroups="l_sol_dynamic.tableGroups"
                :combos="l_sol_dynamic.combos"
                :hero="l_sol_static.players[0]"
                :opponent="l_sol_static.players[1]"
                :players="l_sol_static.players"
                :catDraws="l_sol_static.catDraws"
                :catHands="l_sol_static.catHands"
                :catEqBuckets="l_sol_static.catEqBuckets"
                :catEqBucketsAdvanced="l_sol_static.catEqBucketsAdvanced"
                :hSpot="$store.getters.sol_data_hSpot"
                :bettingInfo="sol_bettingInfo"
                :solution="l_sol_dynamic.solution"
                :solution_picked="$store.getters.sol_data_solution_picked"
                :street="$store.getters.sol_data_street"
                :viewProps="$store.getters.sol_view_viewProps"
                :heroLeft="$store.getters.sol_view_viewProps.heroLeft"
                :filterCombos="$store.getters.sol_filter_combos"
                :filterEvCompare="$store.getters.sol_filter_ev_comparison"
                :filterCategories="$store.getters.sol_filter_categories"
                :evProps="$store.state.solutions.evProps"
                :grouping="grouping"
                :useHex="useHex"
                :showBetsIn="showBetsIn"
                :showFlopContent="showFlopContent"
                :mobile="mobile"
                :max1280="max1280"
                :hasBottom="!mobile"
                :hasCenter="!mobile"
                :rangesMaximized="tabMaximized"
                :heroGroup="heroDetail.group"
                :opponentGroup="opponentDetail.group"
                :heroGroupId="heroDetail.group_id"
                :opponentGroupId="opponentDetail.group_id"
                :tableMouseover="$store.getters.sol_detail_tableMouseover"
                :heroGroupsIds="heroDetail.groups_ids"
                :opponentGroupsIds="opponentDetail.groups_ids"
                :heroHandsIds="heroDetail.hands_ids"
                :opponentHandsIds="opponentDetail.hands_ids"
                :filteredHeroHandsIds="$store.getters.sol_filter_playersHandsIds[0]"
                :playersDetail="$store.getters.sol_detail_players"
                :filteredPlayersHandsIds="$store.getters.sol_filter_playersHandsIds"
                :filteredOpponentHandsIds="$store.getters.sol_filter_playersHandsIds[1]"
                :hasPremiumGameformat="hasPremiumGameformat"
                :gameformat="gameformat"
                :actionHighlighted="$store.getters.sol_filter_actionsHighlighted[0]"
              />
            </template>
            <template v-else>
              <StudyRangesMain
                v-if="tab === 'strategy' || tab === 'range'"
                :namespace="''"
                :canAISolve="true"
                :rangeTab="tab"
                :tableGroups="l_sol_dynamic.tableGroups"
                :combos="l_sol_dynamic.combos"
                :hero="l_sol_static.players[0]"
                :opponent="l_sol_static.players[1]"
                :players="l_sol_static.players"
                :catDraws="l_sol_static.catDraws"
                :catHands="l_sol_static.catHands"
                :catEqBuckets="l_sol_static.catEqBuckets"
                :catEqBucketsAdvanced="l_sol_static.catEqBucketsAdvanced"
                :hSpot="$store.getters.sol_data_hSpot"
                :bettingInfo="sol_bettingInfo"
                :solution="l_sol_dynamic.solution"
                :solution_picked="$store.getters.sol_data_solution_picked"
                :street="$store.getters.sol_data_street"
                :viewProps="$store.getters.sol_view_viewProps"
                :heroLeft="$store.getters.sol_view_viewProps.heroLeft"
                :filterCombos="$store.getters.sol_filter_combos"
                :filterEvCompare="$store.getters.sol_filter_ev_comparison"
                :filterCategories="$store.getters.sol_filter_categories"
                :evProps="$store.state.solutions.evProps"
                :grouping="grouping"
                :useHex="useHex"
                :showBetsIn="showBetsIn"
                :showFlopContent="showFlopContent"
                :mobile="mobile"
                :max1280="max1280"
                :hasBottom="!mobile"
                :hasCenter="!mobile"
                :rangesMaximized="tabMaximized"
                :heroGroup="heroDetail.group"
                :opponentGroup="opponentDetail.group"
                :heroGroupId="heroDetail.group_id"
                :opponentGroupId="opponentDetail.group_id"
                :tableMouseover="$store.getters.sol_detail_tableMouseover"
                :heroGroupsIds="heroDetail.groups_ids"
                :opponentGroupsIds="opponentDetail.groups_ids"
                :heroHandsIds="heroDetail.hands_ids"
                :opponentHandsIds="opponentDetail.hands_ids"
                :filteredHeroHandsIds="$store.getters.sol_filter_playersHandsIds[0]"
                :filteredOpponentHandsIds="$store.getters.sol_filter_playersHandsIds[1]"
                :hasPremiumGameformat="hasPremiumGameformat"
                :gameformat="gameformat"
                :actionHighlighted="$store.getters.sol_filter_actionsHighlighted[0]"
              />
            </template>
          </keep-alive>
          <portal
            to="main_before"
            :order="1"
          >
            <FloatingEvComparePicker
              v-if="!mobile"
              :isVisible="$store.getters.sol_view_viewProps.evComparePickerVisible"
            />
          </portal>
          <keep-alive max="1">
            <StudyRangesBreakdown
              v-if="tab === 'breakdown'"
              :namespace="''"
              :canAISolve="true"
              :actionHighlighted="$store.getters.sol_filter_actionsHighlighted[0]"
              :catDraws="l_sol_static.catDraws"
              :catEqBuckets="l_sol_static.catEqBuckets"
              :catEqBucketsAdvanced="l_sol_static.catEqBucketsAdvanced"
              :catHands="l_sol_static.catHands"
              :combos="l_sol_dynamic.combos"
              :filterCombos="$store.getters.sol_filter_combos"
              :grouping="grouping"
              :hero="l_sol_static.players[0]"
              :heroGroupId="heroDetail.group_id"
              :heroHandsIds="heroDetail.hands_ids"
              :isPreflop="sol_isPreflop"
              :mobile="mobile"
              :showBetsIn="showBetsIn"
              :showFlopContent="showFlopContent"
              :solution_picked="$store.getters.sol_data_solution_picked"
              :tableGroups="l_sol_dynamic.tableGroups"
              :useHex="useHex"
              :viewProps="$store.getters.sol_view_viewProps"
            />
          </keep-alive>
        </template>
      </TabBoxStudy>
    </template>
    <template #after>
      <StudyMessageOverlay
        v-if="studyMessages"
        :messages="studyMessages"
        :canAISolve="true"
        :hasShortcutBtn="hasShortcutBtn"
        style="z-index: 2"
        :solElite="solElite"
        :street="hSpot_street"
        :pageKey="soltab === 'reports' ? 'reports' : 'solutions'"
        :historySpots="historySpotsComplete"
        @click:prefill="handlePrefillClick"
      />
    </template>
  </LayoutStudy>
</template>

<script>
import StudyControlsMain from '@/components/Study/StudyControlsMain'
import StudyControlsReports from '@/components/Study/StudyControlsReports'
import StudyControlsReportsFilters from '@/components/Study/StudyControlsReportsFilters'
import StudyControlsRanges from '@/components/Study/StudyControlsRanges'
import StudyFiltersPills from '@/components/Study/StudyFiltersPills'
import { throttle } from 'lodash'
import LayoutStudy from '@/layouts/LayoutStudy'
import PokerHistoryEvents from '@/components/Poker/PokerHistoryEvents/PokerHistoryEvents'
import StudyRangesMain from '@/components/Study/StudyRangesMain'
import StudyRangesMain2 from '@/components/Study/StudyRangesMain2'
import StudyRangesAside from '@/components/Study/StudyRangesAside'
import StudyRangesBreakdown from '@/components/Study/StudyRangesBreakdown'
import TabBoxStudy from '@/components/Study/TabBoxStudy'
import StudyMessageOverlay from '@/components/Poker/Overlays/StudyMessageOverlay'
import StudyTableTile from '@/components/Study/StudyTableTile'
import FloatingEvComparePicker from '@/components/EvComparePicker/FloatingEvComparePicker'

import StudyReportsAside from '@/components/Study/StudyReportsAside'
import StudyReportsMain from '@/components/Study/StudyReportsMain'

import tier_mix from '@/mixins/tier_mix'

export default {
  name: 'StudyDataLayoutLayer',
  components: {
    LayoutStudy,
    PokerHistoryEvents,
    StudyRangesAside,
    StudyRangesBreakdown,
    StudyRangesMain,
    StudyRangesMain2,
    TabBoxStudy,
    StudyMessageOverlay,
    StudyTableTile,
    StudyReportsAside,
    StudyReportsMain,
    FloatingEvComparePicker,
    StudyControlsMain,
    StudyControlsReports,
    StudyControlsReportsFilters,
    StudyControlsRanges,
    StudyFiltersPills,
  },
  mixins: [tier_mix],
  props: {
    namespace: { default: '' },
  },
  data() {
    this.l_soltab = ''
    this.l_rep_params = {}
    this.l_sol_params = {}
    return {}
  },
  // },
  methods: {
    getData: throttle(function (caller) {
      if (this.soltab === 'reports') {
        this.rep_getData(caller)
      } else {
        this.sol_getData()
      }
    }, 40),
    rep_getData(caller) {
      if (this.solElite.want_use && !this.$store.getters.user_has_flag('CR_REPORTS')) return
      if (!this.hSpot) return
      if (this.historyLoading) return
      if (this.soltab !== 'reports') return
      if (this.hSpot.placeholder) return
      if (this.hSpot.type === 'showdown') return
      if (this.hSpot_street === 'preflop') return
      if (this.hSpot_street === 'river') return
      if (
        this.hSpot_street === 'turn'
          ? this.$store.getters.street_board('flop').includes('Ee')
          : false
      )
        return

      const params = this.$store.getters.solparams_reports
      if (JSON.stringify(this.l_rep_params) === JSON.stringify(params) && !this.solElite.want_use) {
        return
      }
      this.l_rep_params = params

      this.$store.dispatch('api_poker_reports')
      this.resetHistoryErrorMessages()
    },
    sol_getData() {
      if (!this.hSpot) return
      if (this.hSpot.forced_fold) return
      if (this.soltab === 'reports') return
      if (this.hSpot.type === 'showdown') return
      if (this.hSpot.placeholder) return
      if (this.historyLoading) return
      if (this.cussolLoading) return
      if (this.sol_noBoardCards) return
      if (this.hasEliteSingleFlopOnly) return

      const params = this.$store.getters.solparams_strategy
      if (
        // mobile view stop-check
        (params.custom_solution_id &&
          params.custom_solution_id !== this.hSpot.custom_solution_id) ||
        // correct board check
        (this.l_sol_params.custom_solution_id &&
          this.l_sol_params.board !== params.board &&
          this.l_sol_params.custom_solution_id === params.custom_solution_id) ||
        JSON.stringify(this.l_sol_params) === JSON.stringify(params)
      ) {
        // custom_solution_id check
        // updating board udates hSpot.board so params dont match but what matters is custom_solution_id which is not updated yet
        // maybe we should have a think about how to do this fetch differently cos too many things can trigger this and then you have to stop it
        return
      }
      this.l_sol_params = params

      // debugger
      this.$store.dispatch('api_poker_solution')
      this.resetHistoryErrorMessages()
    },
    resetHistoryErrorMessages() {
      // reset hanging error messages
      const calls = ['api_poker_history', 'api_poker_next_actions']
      calls.forEach(mutation => {
        if (this.$store.getters.api_get(mutation).error) {
          this.$store.commit('api_reset', { namespace: null, key: mutation })
        }
      })
    },
    handleNodeEditClick(item) {
      const tmpNamespace = 'tmp/primary'
      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.namespace,
        to_namespace: tmpNamespace,
        queryGroup: 'nodedit',
      })
      const dialog = `solfigr-nodeedit-dialog_edit-solution_${
        this.namespace ? `namespace-${this.namespace}_` : ''
      }tmpNamespace-${tmpNamespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    handleNodeLockClick(item) {
      const tmpNamespace = 'tmp/primary'
      const dialog = `solfigr-nodelock-dialog_edit-solution_tmpNamespace-${tmpNamespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    handleNodeCompareClick() {
      const tmpNamespace = 'tmp/primary'
      const dialog = `solfigr-nodecompare-dialog_tmpNamespace-${tmpNamespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    handlePrefillClick() {
      const tmpNamespace = 'tmp/primary'
      const mode =
        this.$store.getters.flop_board && this.solElite.can_use ? 'keepboard' : 'createnew'

      let dialog = 'solfigr-create-custom-solution-dialog'
      dialog = `${dialog}_namespace-${tmpNamespace}_instaPrefill-true_mode-${mode}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
  },
  computed: {
    hSpotsProps() {
      return {
        namespace: '',
        hasGameformat: true, // show first tile with solution info
        hasInitialLoad: true,
        hasWatcherEnabled: true,
        clickableFlopSolutionEndNode: true,
        isMinimizedVertical: this.mobile && !this.$store.getters.screen_landscape,
        mobile: this.mobile,

        shortcutBtnsHorizontal: true, // show ShortcutBtns
        canAISolve: true, // passed to ShortcutBtns which passes it to shortcut dialog which is shown for presolved sols only
        hiddenShortcutBtns: this.solElite.is_using ? ['shortcut'] : [],

        solElite: this.solElite,
        skeletonTiles: this.solElite.is_preflop ? 1 : null,
        hasTurnPreload: !this.solElite.is_using, // whenether to make turn preload call for (presolved sols only)
        noNextActionsWithoutBoard: this.solElite.is_using && !this.sol_usingCussolReports,

        useTreePreview: this.sol_usingCussolReports,
        customTreeId: this.sol_usingCussolReports ? this.solElite.custom_tree_id : '',
        ggStreet: this.sol_usingCussolReports && 'turn',
        hasGGSaveSpot: !this.sol_usingCussolReports,
        clickableGG: this.sol_usingCussolReports,

        hasEmptyBoard: this.sol_usingCussolReports,
        clickableBoard: !this.sol_usingCussolReports,
        showBoardWhenLoading: !this.sol_usingCussolReports,

        hasNodeEdit: this.solElite.is_using && !this.sol_usingCussolReports,
        hasNodeMenu: this.solElite.is_using && !this.sol_usingCussolReports,

        hasFlopPrefillBtn: !this.solElite.is_using,
        hasFlopSolutionEndNode: !this.solElite.is_using, // shows message that presolved solutions end - continue with AI (presolved sols only)
      }
    },
    requiredToGenerateReport() {
      if (!this.$store.getters.user_has_flag('CR_REPORTS')) return false
      const status = this.$store.getters.rep_data_customReportMeta.status
      return status !== 'done' && status !== 'pending'
    },
    sol_usingCussolReports() {
      return this.$store.getters.sol_usingCussolReports // refresh history for all spots for reports & strategy toggle
    },
    noReports() {
      return !this.$store.getters.user_has_flag('CR_REPORTS') && this.solElite.is_using
    },
    hasShortcutBtn() {
      return !this.solElite.is_using
    },
    soltab() {
      return this.$store.getters.sw_tabs_study
    },
    l_rep_dynamic() {
      const res = {
        items: this.$store.getters.rep_data_items(),
        totalsItems: this.$store.getters.rep_data_totalsItems,
        viewProps: this.$store.getters.rep_data_viewProps,
      }
      return this.$store.getters.rep_data_viewProps ? res : res
    },

    sol_isPreflop() {
      return this.$store.getters.sol_data_street === 'preflop'
    },
    rep_isPreflop() {
      return this.$store.getters.rep_data_street === 'preflop'
    },

    l_sol_dynamic() {
      const res = {
        tableGroups: this.$store.getters.sol_data_tableGroups(),
        combos: this.$store.getters.sol_data_combos(),
        solution: this.$store.getters.sol_data_solution(),
      }
      return this.$store.getters.sol_data_updated && this.$store.getters.sol_filter_active
        ? res
        : res
    },
    heroDetail() {
      return this.$store.getters.sol_detail_players[0]
    },
    opponentDetail() {
      return this.$store.getters.sol_detail_players[1]
    },
    l_sol_static() {
      const res = {
        solData: this.$store.getters.sol_data_solData(),
        catDraws: this.$store.getters.sol_data_catDraws(),
        catHands: this.$store.getters.sol_data_catHands(),
        catEqBuckets: this.$store.getters.sol_data_catEqBuckets(),
        catEqBucketsAdvanced: this.$store.getters.sol_data_catEqBucketsAdvanced(),
        players: this.$store.getters.sol_data_players(),
        // TODO rm after 3way rls
        hero: this.$store.getters.sol_data_players()[0],
        opponent: this.$store.getters.sol_data_players()[1],
      }
      return this.$store.getters.sol_data_updated ? res : res
    },

    filterActive() {
      if (this.soltab === 'reports') {
        return (
          this.$store.getters.sol_filter_combos.actions.length ||
          this.$store.getters.rep_turn_filterHand ||
          Object.keys(this.repFlopFilterParams).length
        )
      }
      return this.$store.getters.sol_filter_combos.status !== 'inactive'
    },

    mobileLandscape() {
      return this.mobile && this.$store.getters.screen_landscape
    },
    max1280() {
      return this.$store.getters.screen_max1280
    },

    tabMaximized() {
      if (this.mobile) return false
      if (this.mobileLandscape) return false
      const tab = this.$store.getters.sw_tabs_study
      return this.$store.getters[`sw_study_${tab}_fullscreen`] === 'on'
    },

    showFlopContent() {
      return this.solElite?.is_using || !this.sol_isPreflop
    },
    useHex() {
      return this.$store.getters.sw_actions_grouping === 'swv_grouping_none'
    },
    grouping() {
      return this.$store.getters.sw_actions_grouping
    },
    showBetsIn() {
      return this.$store.getters.show_bets_in
    },
    showEvIn() {
      return this.$store.getters.show_ev_in
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },

    gameformat() {
      // TODO this is misleading but its a hack for down the line props
      return this.solElite?.want_use ? { gm_type: 'elite' } : this.$store.getters.gameformat
    },
    solElite() {
      return this.$store.getters.sol_elite
    },
    hasPremiumGameformat() {
      if (this.solElite?.want_use) {
        const { subs } = this.$store.getters.user_info
        const anyPremiumPurchased = subs.some(i => i.plan.tier === 'PREMIUM')
        const anyElitePurchased = subs.some(i => i.plan.tier === 'ELITE')
        return !!(anyPremiumPurchased || anyElitePurchased)
      }
      return ['PREMIUM', 'ELITE'].some(i => this.gameformat?.subscription_tier === i)
    },

    //---------
    hSpot() {
      return this.$store.getters.history_spot
    },
    historySpotsComplete() {
      return this.$store.getters.history_spots_complete
    },
    hSpot_street() {
      return this.hSpot?.street
    },
    preflopOnlyGametype() {
      return this.$store.getters.preflopOnlyGametype
    },
    sol_hsBoard() {
      return this.$store.getters.history_spot_board
    },
    sol_noBoardCards() {
      return this.hSpot_street !== 'preflop' && this.sol_hsBoard.some(i => i.includes('E'))
    },

    historyCall() {
      // console.log(this.$store.getters.api_get('api_poker_history'))
      return this.$store.getters.api_get('api_poker_history')
    },
    historyLoading() {
      return this.nextActionsCall?.loading || this.historyCall?.loading
    },
    historyStatus() {
      return this.historyCall.status
    },
    historyError() {
      return this.nextActionsCall?.error || this.historyCall?.error
    },
    nextActionsCall() {
      return this.$store.getters.api_get('api_poker_next_actions')
    },
    nextActionsStatus() {
      return this.nextActionsCall.status
    },
    cusssolCall() {
      return this.$store.getters.api_get('api_poker_custom_solution', this.namespace)
    },
    cussolLoading() {
      return this.cusssolCall?.loading
    },
    cussolPostStatus() {
      return this.cusssolCall?.method === 'post' && this.cusssolCall?.status
    },

    sol_apiCall() {
      return this.$store.getters.api_get('api_poker_solution')
    },
    sol_loading() {
      return this.sol_apiCall.loading
    },
    sol_loaded() {
      return this.sol_apiCall.loaded
    },
    sol_status() {
      return this.sol_apiCall.status
    },
    sol_error() {
      return this.sol_apiCall.error
    },

    rep_apiCall() {
      return this.$store.getters.api_get('api_poker_reports')
    },
    rep_loading() {
      return this.rep_apiCall.loading
    },
    rep_loaded() {
      return this.rep_apiCall.loaded
    },
    rep_status() {
      return this.rep_apiCall.status
    },
    rep_error() {
      return this.rep_apiCall.error
    },

    studyMessages() {
      if (this.soltab === 'reports') {
        return this.rep_messages
      }
      return this.sol_messages
    },

    rep_messages() {
      // return [
      // 'loading',
      // 'error_loading_solution',
      // 'filtered_204',
      // '204',
      // '403',
      // '429',
      // 'preflopOnlyGametype',
      // 'postflop_equity_only',
      // 'no_river',
      // 'spins_reports_basic_only',
      // 'select_board_strategy',
      // 'turnZeroDataValues',
      // 'FREE_unavailable',
      // 'trialUser403',
      // 'starterUser403',
      // ]

      const opts = [
        {
          key: 'custom_reports_payment_required',
          val: this.requiredToGenerateReport,
        },
        {
          key: 'no_custom_sol_reports',
          val: !this.$store.getters.user_has_flag('CR_REPORTS') && this.solElite.is_using,
        },
        {
          key: 'loading',
          val: (this.rep_loading || this.historyLoading) && !this.solElite.want_use,
        },
        { key: 'no_river', val: this.hSpot_street === 'river' },
        {
          key: 'no_custom_report_turn',
          val: this.hSpot_street === 'turn' && this.usingCussolReports,
        },
        { key: 'postflop_equity_only', val: this.hSpot_street === 'preflop' },

        { key: 'preflopOnlyGametype', val: this.preflopOnlyGametype },
        {
          key: 'spins_reports_basic_only',
          val:
            this.rep_status === 204 &&
            this.gameformat.group === 'spins' &&
            this.gameformat.type !== 'basic',
        },
        {
          key: 'select_board_strategy',
          val:
            this.hSpot_street === 'turn'
              ? this.$store.getters.street_board('flop').includes('Ee')
              : false,
        },

        {
          key: 'filtered_204',
          val:
            this.rep_status === 204 &&
            (this.$store.getters.turn_filter_hand || Object.keys(this.repFlopFilterParams).length),
        },
        { key: 'trialUser403', val: this.gameformatTrial && this.rep_status === 403 },
        { key: 'starterUser403', val: this.gameformatStarter && this.rep_status === 403 },
        { key: 'FREE_unavailable', val: this.gameformatFree && this.rep_status === 403 },
        { key: '204', val: this.rep_status === 204 },
        { key: '403', val: this.rep_status === 403 },
        { key: '429', val: this.rep_status === 429 },

        {
          key: 'turnZeroDataValues',
          val: this.hSpot_street === 'turn' ? this.turnZeroDataValues : false,
        }, // 200 res code but no data
        { key: 'error_loading_solution', val: this.rep_error || this.historyError },
        {
          key: 'custom_reports_on_demand',
          val:
            this.$store.getters.user_has_flag('CR_REPORTS') &&
            this.$store.getters.user_has_flag('CR_REPORTS') &&
            this.solElite.is_using &&
            this.soltab === 'reports',
        },
      ]
      let res = null
      opts.forEach(i => {
        if (!res && i.val) {
          res = [i.key]
        }
      })
      return res
    },
    turnZeroDataValues() {
      // console.log(this.$store.getters.api_get_data('api_poker_reports'))
      // @TODO add flag here
      const res =
        this.$store.getters.api_get_data('api_poker_reports')?.player_totals ||
        this.$store.getters.api_get_data('api_poker_reports')?.totals
      return !res
    },

    sol_bettingInfo() {
      return {
        pot: this.$store.getters.sol_data_hSpot.pot,
        showEvIn: this.showEvIn,
        showEvIcmIn: this.$store.getters.show_ev_icm_in,
        evIcmConverters: this.l_sol_static.players.map(player => player?.tournament_evs_converter),
      }
    },
    rep_bettingInfo() {
      return { showEvIn: this.showEvIn, pot: this.$store.getters.rep_data_hSpot.pot }
    },

    sol_messages() {
      // TODO unify solMessages with builder and popups
      // return [
      // 'loading',
      // 'error_loading_solution',
      // 'error_400_TREE_IS_TOO_BIG',
      // 'custom_sols_flop_elite_only',
      // '204',
      // '204_elite',
      // '403',
      // '429',
      // 'preflopOnlyGametype',
      // 'select_board_strategy',
      // ]
      // console.log(this.historyError)
      const solutionTooBig =
        this.historyError?.status === 400 && this.historyError?.data?.code === 'TREE_IS_TOO_BIG'

      const opts = [
        { key: 'loading', val: this.sol_loading || this.historyLoading },

        { key: 'loading', val: this.solElite.loading_what === 'custom_solution' },

        {
          key: 'forced_fold',
          val: this.hSpot?.forced_fold,
        },

        { key: 'custom_sols_flop_elite_with_rake_only', val: this.flopRakeEliteForbidden },
        { key: 'custom_sols_preflop_elite_with_rake_only', val: this.preflopRakeEliteForbidden },
        { key: 'custom_sols_flop_elite_only', val: this.flopEliteForbidden },
        { key: 'custom_sols_preflop_elite_only', val: this.preflopEliteForbidden },

        { key: 'error_400_TREE_IS_TOO_BIG', val: solutionTooBig },
        { key: '204_elite', val: this.solElite.is_using && this.sol_status === 204 },

        { key: 'preflopOnlyGametype', val: !this.solElite.want_use && this.preflopOnlyGametype },
        { key: 'select_board_strategy', val: this.sol_noBoardCards },

        { key: '204', val: this.sol_status === 204 },
        { key: '403', val: this.sol_status === 403 },
        { key: '429', val: this.sol_status === 429 },
        // { key: 'error_loading_solution', val: this.sol_error || this.historyError },
        { key: 'error_loading_solution', val: this.sol_error || this.historyError },
      ]
      let res = null
      opts.forEach(i => {
        if (!res && i.val) {
          res = [i.key]
        }
      })

      // res = [
      //   'custom_sols_flop_elite_only',
      //   'custom_sols_preflop_elite_only',
      //   'custom_sols_flop_elite_with_rake_only',
      //   'custom_sols_preflop_elite_with_rake_only',
      // ]
      // console.log(res, {
      //   flopEliteForbidden: this.flopEliteForbidden,
      //   preflopEliteForbidden: this.preflopEliteForbidden,
      //   flopRakeEliteForbidden: this.flopRakeEliteForbidden,
      //   preflopRakeEliteForbidden: this.preflopRakeEliteForbidden,
      // })
      return res
    },

    reptab() {
      return this.hSpot_street === 'flop'
        ? this.$store.getters.sw_reports_flop_grouping
        : this.$store.getters.sw_reports_turn_grouping
    },
    repFlopFilterParams() {
      return this.$store.getters.ffrf.params || {} // filters_reports_flop
    },
    repFilters() {
      return JSON.stringify(this.repFlopFilterParams) + this.$store.getters.rep_turn_filterHand
    },
    fullscreen() {
      return this.$store.getters[`sw_study_${this.$store.getters.sw_tabs_study}_fullscreen`]
    },
    flopEliteForbidden() {
      return (
        !this.solElite.is_preflop &&
        this.solElite.is_using &&
        (this.nextActionsStatus === 403 ||
          this.historyStatus === 403 ||
          this.cussolPostStatus === 403)
      )
    },
    preflopEliteForbidden() {
      return (
        this.solElite.is_preflop &&
        this.solElite.is_using &&
        (this.nextActionsStatus === 403 ||
          this.historyStatus === 403 ||
          this.cussolPostStatus === 403 ||
          this.solElite.must_upgrade)
      )
    },
    flopRakeEliteForbidden() {
      return this.flopEliteForbidden && this.noRakeFlag
    },
    preflopRakeEliteForbidden() {
      return this.preflopEliteForbidden && this.noRakeFlag
    },
    noRakeFlag() {
      return this.solElite?.is_elite_without_rake
      // const res = [
      //   this.historyCall, //
      //   this.nextActionsCall,
      //   this.cusssolCall,
      // ].reduce((acc, cur) => {
      //   if (acc) return acc
      //   if (cur?.error?.data?.rake_not_allowed) return true
      //   return false
      // }, false)
      // return res
    },
    isCustomReportsPending() {
      return this.$store.getters.rep_data_customReportMeta.status === 'pending'
    },
  },
  watch: {
    repFilters() {
      this.getData('repFilters')
    },
    reptab() {
      this.getData('reptab')
    },
    soltab() {
      const fromStraToreports = this.l_soltab !== 'reports' && this.soltab === 'reports'
      const fromReportsToStra = this.l_soltab === 'reports' && this.soltab !== 'reports'
      if (!this.l_soltab || fromStraToreports || fromReportsToStra) {
        this.l_soltab = this.soltab
        this.getData(`soltab_${this.soltab}`)
      }
    },
    hSpot() {
      // @TODO reports data should not be fetched with every hsspot update, but only after confirmation
      this.getData('hSpot')
    },
    fullscreen() {
      this.$store.dispatch('globals_action', `horizontal_scroll_check`)
    },
  },
}
</script>
